import Vue from "vue";
import axios from "axios";

const ENDPOINT =
  "https://he8sk4pldg.execute-api.eu-west-1.amazonaws.com/default/DofusRanking";

const MOCK_DATA = [
  [
    {
      rank: "#",
      name: "Nom",
      server: "Serveur Tempotons",
      points: null,
      class: ""
    },
    {
      rank: "1",
      name: "Didadidudu",
      server: "Temporis V",
      points: 873,
      class: "breed5_1"
    },
    {
      rank: "2",
      name: "Justice",
      server: "Temporis X",
      points: 853,
      class: "breed7_0"
    },

    {
      rank: "3",
      name: "Towlie",
      server: "Temporis X",
      points: 806,
      class: "breed2_1"
    },
    {
      rank: "4",
      name: "Eagle",
      server: "Temporis II",
      points: 805,
      class: "breed6_0"
    },
    {
      rank: "5",
      name: "Tesseract",
      server: "Temporis X",
      points: 804,
      class: "breed5_0"
    }
  ],
  [
    {
      rank: "#",
      name: "Nom",
      server: "Serveur Tempotons",
      points: null,
      class: ""
    },
    {
      rank: "1",
      name: "Didadidudu",
      server: "Temporis V",
      points: 873,
      class: "breed5_1"
    },
    {
      rank: "2",
      name: "Justice",
      server: "Temporis X",
      points: 853,
      class: "breed7_0"
    },
    {
      rank: "3",
      name: "Eagle",
      server: "Temporis II",
      points: 836,
      class: "breed6_0"
    },
    {
      rank: "4",
      name: "Towlie",
      server: "Temporis X",
      points: 806,
      class: "breed2_1"
    },
    {
      rank: "5",
      name: "Tesseract",
      server: "Temporis X",
      points: 804,
      class: "breed5_0"
    }
  ]
];

const mock = false;
let mockIndex = 0;

const store = Vue.observable({
  ranking: []
});

async function getLadder() {
  if (!mock) {
    const data = await axios.get(ENDPOINT).then(res => res.data);
    store.ranking = data.map((item, index) => ({
      ...item,
      key: item.name === "******" ? `anon-${index}` : item.name
    }));
  } else {
    store.ranking = MOCK_DATA[mockIndex].map((item, index) => ({
      ...item,
      key: item.name === "******" ? `anon-${index}` : item.name
    }));
    mockIndex = (mockIndex + 1) % MOCK_DATA.length;
  }
}

setInterval(getLadder, 1000 * 60);

export default {
  install(Vue) {
    getLadder();
    Vue.prototype.$dofus = store;
  }
};
